export default {
  methods: {
    //从画布删除元素
    destroyZrCom() {
      if (this.$zr) {
        if (this.$zrComponent) {
          this.$zr.remove(this.$zrComponent)
        }
      }
    },
  },
  mounted() {
    this.$zr = this.$parent.$zr
    this.init()
    this.registerEvent()
  },
  beforeDestroy() {
    this.destroyZrCom()
  },
}
